import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeviceStore } from '@/lib/deviceStore';
import { useHeartbeat } from './heartbeat';
import { useSession } from './session';
import { useToast } from './toast';

/**
 * Runs for every route while the principal is an enrolled device: heartbeat (so the admin panel
 * shows the tablet online even while it sits on the lock screen) and revocation handling.
 */
export function DeviceRuntime() {
  const s = useSession();
  const nav = useNavigate();
  const { toast } = useToast();
  const isDevice = s.me?.principal === 'device' && s.me.terminal?.status === 'active';
  const onRevoked = useCallback(() => {
    useDeviceStore.getState().clear();
    void s.signOut().then(() => nav('/enroll', { replace: true }));
    toast('This terminal was revoked by an administrator', 'danger');
  }, [nav, s, toast]);
  useHeartbeat(isDevice, s.me?.terminal?.heartbeat_seconds ?? 60, onRevoked);
  return null;
}
